import '../Enum'
import './AttributeOption'
import './Data/SpatialClasses'
import './Data/SpatialObjects'
import './UI/LightObjectForm'

/** @namespace Accounting */
NS("Accounting");

/**
 * @class
 * @extends Enum
 */
Accounting.AttributeType = Static(Enum, /** @lends Accounting.AttributeType */ {
    Text: 1,
    Date: 2,
    Datetime: 3,
    Numeric: 4,
    Dict: 5,
    Feature: 6,
    Files: 7,
    References: 8,
    Counter: 9,
    TemplatedValue: 10,
    Measuring: 11,
    Cadastre: 12,
    Checkbox: 13,

    itemForm: 'Accounting.UI.LightObjectForm',

    title(value) {
        switch (+value) {
            case this.Text:
                return "Текст";
            case this.Date:
                return "Дата";
            case this.Datetime:
                return "Дата/Время";
            case this.Numeric:
                return "Число";
            case this.Dict:
                return "Справочник";
            case this.Feature:
                return 'Ссылка на гео объект';
           case this.Files:
               return 'Файлы';
            case this.References:
                return 'Ссылка на объект учета';
            case this.Counter:
                return 'Счетчик';
            case this.TemplatedValue:
                return 'Значение по шаблону';
            case this.Measuring:
                return 'Отчетный показатель';
            case this.Cadastre:
                return 'Кадастровый номер';
            case this.Checkbox:
                return 'Флажок';
            default:
                return this.ParentCall();
        }
    },
    /**
     * @param {number} value
     * @returns {Array.<number>} array of Accounting.AttributeOption enum values, e.i. array of available attribute options
     */
    options(value) {
        switch (+value) {
            case this.Text:
                return [Accounting.AttributeOption.IsName, Accounting.AttributeOption.MaxLength, Accounting.AttributeOption.LineCount];
            case this.Date:
            case this.Datetime:
                return [Accounting.AttributeOption.MinValue, Accounting.AttributeOption.MaxValue];
            case this.Numeric:
                return [Accounting.AttributeOption.Unit, Accounting.AttributeOption.MinValue, Accounting.AttributeOption.MaxValue, Accounting.AttributeOption.Precision];
            case this.Checkbox:
                return [];
            case this.Dict:
                return [Accounting.AttributeOption.Dict, Accounting.AttributeOption.Multiple, Accounting.AttributeOption.MaxQuantity];
            case this.Feature:
                return [Accounting.AttributeOption.Editable, Accounting.AttributeOption.Layer, Accounting.AttributeOption.SearchAttribute];
           case this.Files:
               return [Accounting.AttributeOption.MaxQuantity, Accounting.AttributeOption.MaxSize, Accounting.AttributeOption.FileType];
            case this.References:
                return [Accounting.AttributeOption.Kind, Accounting.AttributeOption.Multiple];
            case this.Counter:
                return [Accounting.AttributeOption.Sequence];
            case this.TemplatedValue:
                return [Accounting.AttributeOption.IsName, Accounting.AttributeOption.Template];
            case this.Measuring:
                return [Accounting.AttributeOption.Schedule, Accounting.AttributeOption.Kind];
            default:
                return [];
        }
    },

    control(value) {
        switch (+value) {
            case this.Numeric:
                return {
                    type: "text",
                    'path-customizer': 'Object',
                };
            case this.Text:
                return {
                    type: "text-area",
                    'path-customizer': 'Object',
                };
            case this.Date:
                return {
                    type: "datepicker",
                    'alt-format': 'YYYY-MM-DD',
                    'path-customizer': 'Object',
                };
            case this.Datetime:
                return {
                    type: "datetimepicker",
                    'alt-format': 'YYYY-MM-DD HH:mm:ss',
                    'path-customizer': 'Object',
                };
            case this.Checkbox:
                return {
                    type: 'checkbox',
                }
            case this.Dict:
                return {
                    type: "dyn-dict-select",
                    'show-empty': true,
                    'title-key': 'value',
                    'value-key': 'id',
                    'path-customizer': 'Object',
                };
			case this.Files:
				return {
					type: "files",
				};
            case this.Feature:
                return {
                    type: 'feature',
					'layer-source': 'Accounting.Data.SpatialClasses',
					'feature-source': 'Accounting.Data.SpatialObjects',
                    'map-center': [5467158.342756814, 7516014.679388353],
                    'map-zoom': 12,
                    'area-units': 'ha',
                    'attribute-helper': 'attributeHelper',
                    'path-customizer': 'Object',
                };
            case this.References:
                return {
                    type: 'reference-select',
                    columns: [{
                        name: 'id',
                        width: '12%',
                        title: 'ID'
                    }],
                    'item-form': this.itemForm,
                    'title-key': 'name',
                    'value-key': 'id',
                    'path-customizer': 'Object',
                };
            case this.Counter:
                return {
                    type: "counter",
                    'path-customizer': 'Object',
                };
            case this.TemplatedValue:
                return {
                    type: "label",
                    'path-customizer': 'Object',
                };
            case this.Measuring:
                return {
                    type: 'reference-select',
                    columns: [{
                        name: 'id',
                        width: '12%',
                        title: 'ID'
                    }, {
                        name: 'datetime',
                        title: 'Дата'
                    }/*, {
                        name: 'attributes.2',
                        title: 'Дата'
                    }*/],
                    'item-form': this.itemForm,
                    'title-key': 'name',
                    'value-key': 'id',
                    'path-customizer': 'Object',
                };
			case this.Cadastre:
				return {
					type: "cadastre",
					'source': 'Cadastre/Web/Cadnums/find',
					'column': 'cadnum',
					'columns': 'cadnum|docaddress',
					'path-customizer': 'Object',
				};
            default:
                return {
                    type: "text",
                    'path-customizer': 'Object',
                };
        }
    }
});
